import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_2: FaireProductEntity = {
  token: "viverano-2",
  type: "product",
  name: "Flower Pointelle Knit Baby Blanket & Flower Rattle Gift SET",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/b6d1817020fa9b366ba8b71a65eb4f794b7e07d08bef4ae9fad90812bbb7c560.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1977,1977,x124,y247,safe&width=720",
  priceDollars: 32,
  msrpDollars: 55,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_baby-accessories"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
